import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useAuthStore } from '../hooks/useAuth';
import { hasPermission, type AppPermission } from '../lib/permissions';
import { Card } from './ui/Card';

interface PermissionRouteProps {
  children: React.ReactNode;
  permission: AppPermission;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ children, permission }) => {
  const { user, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div className="min-h-[320px] flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-brand-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasPermission(user, permission)) {
    return (
      <div className="min-h-[420px] flex items-center justify-center">
        <Card padding="lg" className="max-w-md text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-500">
            <ShieldAlert className="h-6 w-6" />
          </div>
          <h1 className="text-xl font-bold text-slate-900">Keine Berechtigung</h1>
          <p className="mt-2 text-sm text-slate-500">
            Diese Funktion ist für Benutzer mit erweiterten Rechten vorgesehen.
          </p>
          <Link
            to="/"
            className="mt-6 inline-flex rounded-lg bg-akzent px-4 py-2 text-sm font-bold text-auf-akzent hover:bg-akzent-tief"
          >
            Zum Service-Cockpit
          </Link>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
};

export default PermissionRoute;
